import React from 'react';
import PropTypes from 'prop-types';

export default class Electricity extends React.Component {
  static propTypes = {
    color: PropTypes.string.isRequired,
    style: PropTypes.object.isRequired,
  };

  render() {
    return (
      <svg
        style={this.props.style}
        viewBox='0 0 16 23'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'>
        <g fill={this.props.color}>
          <path d='M5.99706112,22.150601 C5.84006112,22.150601 5.68506112,22.126601 5.53606112,22.079601 C4.86706112,21.870601 4.44106112,21.228601 4.52506112,20.554601 L5.35606112,13.810601 L1.48206112,13.810601 C0.962061118,13.810601 0.490061118,13.557601 0.219061118,13.132601 C-0.0819388818,12.662601 -0.0719388818,12.060601 0.244061118,11.600601 L7.75506112,0.638601046 C8.11006112,0.122601046 8.79906112,-0.118398954 9.41406112,0.0566010462 C10.0880611,0.249601046 10.5320611,0.877601046 10.4700611,1.54960105 L9.87606112,7.99060105 L14.2290611,7.99060105 C14.7490611,7.99060105 15.2380611,8.25760105 15.5030611,8.68760105 C15.8020611,9.16660105 15.7790611,9.77560105 15.4420611,10.236601 L7.21206112,21.542601 C6.93406112,21.923601 6.48006112,22.150601 5.99706112,22.150601 L5.99706112,22.150601 Z M2.52306112,11.810601 L6.48706112,11.810601 C6.77306112,11.810601 7.04606112,11.933601 7.23606112,12.148601 C7.42606112,12.362601 7.51406112,12.648601 7.47906112,12.932601 L6.76106112,18.763601 L13.1470611,9.99060105 L8.77906112,9.99060105 C8.49806112,9.99060105 8.23006112,9.87260105 8.04006112,9.66460105 C7.85106112,9.45760105 7.75806112,9.17860105 7.78406112,8.89960105 L8.29106112,3.39360105 L2.52306112,11.810601 L2.52306112,11.810601 Z'></path>
        </g>
      </svg>
    );
  }
}
